// react
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// components
import { Videos, ChannelCard, Loader } from './';

// ---
import { fetchFromAPI } from '../utils/fetchFromAPI';

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState([]);
  const [videos, setVideos] = useState([]);

  const { id } = useParams();

  console.log(channelDetail);

  useEffect(() => {
    fetchFromAPI(`channels?part="snippet&id=${id}`).then((data) => {
      setChannelDetail(data?.items[0]);
    });

    fetchFromAPI(`search?channelId=${id}&part=snippet&order=date`).then((data) => {
      setVideos(data?.items);
    });
  }, [id]);

  if (!channelDetail?.snippet) return <Loader />;

  return (
    <div className='max-w-screen-xl mx-auto px-2.5 xl:px-0'>
      <ChannelCard channelDetail={channelDetail} />
      <Videos videos={videos} />
    </div>
  );
};

export default ChannelDetail;
